
import { compose } from 'recompose';
import { lensPath, set } from 'ramda';
import { collateralSchema } from './collateral';
import { mkObjectForLoanAppRole } from 'src/utilities/borrowers';




export const mkCollaterals = (loanApp: string, loanRoleId: string) => {
  const objectMeta = mkObjectForLoanAppRole('default', loanApp, loanRoleId)
  return compose(
    set(lensPath(['object_meta']), objectMeta),
  )(collateralSchema());


}
